import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    transportationName: yup.string().required('Transportation name is required'),
    transportationDescription: yup.string().nullable()
})
    .required();
export const AddTransportationModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            transportationName: itemToEdit ? itemToEdit.transportationName : '',
            transportationDescription: itemToEdit ? itemToEdit.transportationDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ transportationName, transportationDescription }) => {
        setIsSubmitting(true);
        console.log('submitting');
        const data = {
            transportationName: transportationName == '' ? null : transportationName,
            transportationDescription: transportationDescription == '' ? null : transportationDescription
        };
        console.log(data);
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editTransportation', {
                transportationId: itemToEdit.id,
                transportationName: data.transportationName,
                transportationDescription: data.transportationDescription
            });
            const new_transportation = response.data.data.new_transportation;
            const updatedTransportation = {
                id: new_transportation.id,
                patientId: new_transportation.patient_id,
                carePlanId: new_transportation.care_plan_id,
                transportationName: new_transportation.transportation_name,
                transportationDescription: new_transportation.transportation_description,
                updatedAt: new Date(new_transportation.updated_at),
                deletedAt: new Date(new_transportation.deleted_at),
                createdAt: new Date(new_transportation.created_at),
                isEditable: new_transportation.is_editable,
                month: new_transportation.month
            };
            onSuccess(updatedTransportation);
        }
        else {
            const response = await axios.post('/api/carePlan/addTransportation', {
                patientId: patientId,
                transportationName: data.transportationName,
                transportationDescription: data.transportationDescription
            });
            const new_transportation = response.data.data.new_transportation;
            const updatedTransportation = {
                id: new_transportation.id,
                patientId: new_transportation.patient_id,
                carePlanId: new_transportation.care_plan_id,
                transportationName: new_transportation.transportation_name,
                transportationDescription: new_transportation.transportation_description,
                updatedAt: new Date(new_transportation.updated_at),
                deletedAt: new Date(new_transportation.deleted_at),
                createdAt: new Date(new_transportation.created_at),
                isEditable: new_transportation.is_editable,
                month: new_transportation.month
            };
            onSuccess(updatedTransportation);
        }
        setIsSubmitting(false);
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between' }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Transportation Need' : 'Add Transportation Need',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Transportation Need"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "transportationName", presets: props.presets, category: "transportation", field: "transportation", placeholder: "e.g., No personal vehicle" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('transportationDescription'), defaultValue: itemToEdit?.transportationDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Transportation Need' : 'Add Transportation Need')))))));
};
